export const idNumberTail = (idNumber: string | undefined | null): string => {
    if (!idNumber) return '';
    return idNumber.length >= 6 ? idNumber.slice(-5) : idNumber;
};

// Returns the resolved AnimalNumber as raw text — explicit AnimalNumber when present,
// otherwise the IdNumber tail. Used for save/match keys (no formatting).
export const resolveEsfAnimalNumber = (item: {
    animalNumber?: string | null;
    idNumber?: string | null;
}): string => {
    if (item.animalNumber) return item.animalNumber;
    return idNumberTail(item.idNumber ?? undefined);
};

// Returns the AnimalNumber for display. When the value is derived from IdNumber
// (either because animalNumber is empty, or the caller explicitly flags it via
// animalNumberIsFromIdNumber), the value is wrapped in parentheses to indicate
// it isn't a real AnimalNumber.
export const getEsfAnimalNumberDisplay = (item: {
    animalNumber?: string | null;
    idNumber?: string | null;
    animalNumberIsFromIdNumber?: boolean | null;
}): string => {
    if (!item.animalNumber) {
        const tail = idNumberTail(item.idNumber);
        return tail ? `(${tail})` : '';
    }
    if (item.animalNumberIsFromIdNumber) return `(${item.animalNumber})`;
    return item.animalNumber;
};
